export default __webpack_public_path__ + "static/media/streaks 150.04c78fe3.svg";